import React from 'react'

import { CustomTheme, B2CCard } from '@masfront/common-b2c'

import { Box, Divider } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import TabPanel from '@material-ui/lab/TabPanel'

import Barrings from '~/barrings/components/Barrings'
import { Subscription } from '~/customer/model/customer.model'
import Services from '~/services/components/Services'
import { TabConfig, B2CTabContextList } from '~/ui/components'

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    card: {
      '&.MuiBox-root .MuiCollapse-wrapperInner .MuiBox-root': {
        padding: theme.spacing(0),
      },
      '&.MuiBox-root > .MuiTabPanel-root': {
        padding: 0,
      },
    },
    tab: {
      padding: 0,
    },
  }),
)

type MainSubscriptionSummaryServicesContainerProps = {
  subscriptionNonFixed?: Subscription
}

const MainSubscriptionSummaryServicesContainer: React.FC<MainSubscriptionSummaryServicesContainerProps> = ({
  subscriptionNonFixed,
}) => {
  const styles = useStyles()
  const tabConfigs: TabConfig[] = [
    {
      label: 'SERVICIOS',
      value: 'services',
      disabled: false,
    },
    {
      label: 'BARRINGS',
      value: 'barrings',
      disabled: false,
    },
  ]

  const subscriptionNonFixedId = subscriptionNonFixed?.id || ''

  return (
    <Box p={6} flexBasis="inherit" height="max-content" data-hook="main-subscription-services-tab">
      <B2CCard
        title="Resumen de servicios"
        dataHookPrefix="services-summary"
        className={styles.card}
      >
        <B2CTabContextList subTab tabConfigs={tabConfigs} queryParam="subtab">
          <Divider className="strong" />
          <TabPanel value={tabConfigs[0].value} className={styles.tab}>
            <Services subscriptionId={subscriptionNonFixedId} />
          </TabPanel>
          <TabPanel value={tabConfigs[1].value} className={styles.tab}>
            <Barrings subscriptionId={subscriptionNonFixedId} />
          </TabPanel>
        </B2CTabContextList>
      </B2CCard>
    </Box>
  )
}

export default MainSubscriptionSummaryServicesContainer
